/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Location View - TabPanel
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

// Design System
import Icon from '@material-ui/icons/Email';
import CircularProgress from '@material-ui/core/CircularProgress';

function EmailIcon(props) {
  const { isLoading, size, ...rest } = props;
  const classes = styles();

  return (
    <div className={classes.root}>
      <Icon {...rest} />
      {isLoading && (
        <CircularProgress
          size={size}
          className={classes.progress}
          style={{ marginTop: -((size || 40) / 2), marginLeft: -((size || 40) / 2) }}
        />
      )}
    </div>
  );
}

EmailIcon.propTypes = {
  isLoading: PropTypes.bool,
};

const styles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
}));

export default EmailIcon;
